import { Extension } from '@tiptap/core';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const NonBreakingSpaceHighlight = Extension.create({
  name: 'nonBreakingSpaceHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('nonBreakingSpaceHighlight'),
        props: {
          decorations(state) {
            const decorations: Decoration[] = [];

            state.doc.descendants((node, pos) => {
              if (node.isText && node.text) {
                const text = node.text;
                for (let i = 0; i < text.length; i++) {
                  if (text[i] === '\u00A0') {
                    decorations.push(
                      Decoration.inline(pos + i, pos + i + 1, {
                        class: 'non-breaking-space',
                      }),
                    );
                  }
                }
              }
            });

            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});
